import {Sparkles, ShieldCheck, Lock} from 'lucide-react'
import PlanosAssinatura from '../components/PlanosAssinatura'

function RenovarAcesso() {
  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      {/* Header nav */}
      <header className="sticky top-0 z-40 bg-[#F8F4EF]/90 backdrop-blur-sm border-b border-[#EDE0D4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <a
            href="/assinar"
            className="flex items-center gap-2 min-w-0"
          >
            <div className="shrink-0 w-8 h-8 sm:w-9 sm:h-9 bg-[#2D6A4F] rounded-full flex items-center justify-center">
              <Sparkles className="w-4 h-4 sm:w-4.5 sm:h-4.5 text-white" />
            </div>
            <span className="font-cormorant font-semibold text-[#2C2C2A] text-sm sm:text-lg md:text-xl leading-tight truncate">
              Diagnóstico de Saúde e Emoções
            </span>
          </a>
          <nav className="flex items-center gap-2 sm:gap-3 shrink-0">
            <a
              href="https://www.descubraseusoleos.com.br/admin"
              className="inline-flex items-center justify-center min-h-[40px] sm:min-h-[44px] px-3 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-medium text-[#2D6A4F] border border-[#2D6A4F] hover:bg-[#D8F3DC] transition-colors"
            >
              Entrar
            </a>
          </nav>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-10 sm:py-14 space-y-10">

        {/* ── HERO ── */}
        <section className="text-center space-y-5">
          <div className="inline-flex items-center gap-2 bg-[#FAEEDA] text-[#854F0B] text-xs font-medium px-4 py-2 rounded-full">
            <Lock className="w-3.5 h-3.5" />
            Acesso expirado
          </div>
          <h1 className="font-cormorant font-semibold text-[#2C2C2A] text-3xl sm:text-4xl md:text-5xl leading-tight">
            Renove seu acesso ao Diagnóstico de Saúde e Emoções
          </h1>
          <p className="text-[#5F5E5A] text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
            Seu acesso expirou, mas seus dados e contatos estão salvos e seguros. Renove sua assinatura anual e continue usando o Sistema Descubra seus Óleos com todos os recursos.
          </p>

          <div className="flex items-center justify-center gap-2 text-xs text-[#5F5E5A] pt-1">
            <ShieldCheck className="w-4 h-4 text-[#2D6A4F]" />
            <span>Seus leads e dados continuam protegidos no painel.</span>
          </div>
        </section>

        {/* ── ASSINATURA ── */}
        <section>
          <PlanosAssinatura />

          <p className="text-xs text-[#5F5E5A] text-center mt-6">
            Pagamento seguro processado pela Hotmart.
          </p>
        </section>

        <div className="pb-6" />
      </div>
    </div>
  )
}

export default RenovarAcesso
